import { connect } from 'react-redux';
import withPGTranslation from '../../../config/withPGTranslation';
import Footer from './footer';
import { trackDownloadAppEventIfNeed } from '../../../actions/analytics';

const mapStateToProps = ({ application: { dynamicConfig } }) => ({ url: dynamicConfig?.url });

export default connect(mapStateToProps, {
  trackDownloadAppEventIfNeed
})(withPGTranslation(Footer));
